import React from "react";
import { Anchor, Compass, MapPin, Radio, ShieldCheck, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { marinaDetailPath } from "@/lib/marinaUrls";

export default function PremiumMarinaListItem({ copy, marina, ratingSummary, prefix, onPreview, onFocus }) {
  const rating = Number(ratingSummary?.average || marina.rating || 0);
  const price = marina.price_per_night ? `${marina.price_per_night} ${marina.currency || "EUR"}` : copy.askMarina;
  const facilities = (marina.facilities || []).slice(0, 5);

  return (
    <article
      onMouseEnter={() => onFocus?.(marina)}
      className="group rounded-[1.5rem] border border-border bg-card p-4 text-foreground shadow-lg shadow-ocean/5 transition hover:border-primary/45 hover:shadow-xl"
    >
      <div className="grid gap-4 lg:grid-cols-[8rem_1fr_auto] lg:items-center">
        <div className="relative h-32 overflow-hidden rounded-2xl bg-slate-900 lg:h-28">
          {marina.image_url ? (
            <img src={marina.image_url} alt={`${marina.name} marina`} loading="lazy" className="h-full w-full object-cover" />
          ) : (
            <div className="grid h-full place-items-center bg-gradient-to-br from-cyan-950 to-blue-950"><Anchor className="h-8 w-8 text-cyan-100" /></div>
          )}
        </div>

        <div className="min-w-0 space-y-3">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="min-w-0">
              <h3 className="truncate text-xl font-black">{marina.name}</h3>
              <p className="mt-1 flex items-center gap-1.5 text-sm text-muted-foreground"><MapPin className="h-4 w-4" /> {marina.city}, {marina.region || marina.country}</p>
            </div>
            <Badge className="bg-primary text-primary-foreground hover:bg-primary">{marina.flag} {marina.country}</Badge>
          </div>

          <div className="flex flex-wrap gap-2 text-sm">
            <Badge variant="outline"><Star className="mr-1 h-3 w-3" /> {rating ? rating.toFixed(1) : "—"}</Badge>
            <Badge variant="outline"><Radio className="mr-1 h-3 w-3" /> VHF {marina.vhf_channel || "—"}</Badge>
            <Badge variant="outline"><ShieldCheck className="mr-1 h-3 w-3" /> {marina.sheltered_from_wind ? copy.protected : copy.good}</Badge>
            <Badge variant="outline">{price}</Badge>
          </div>

          {!!facilities.length && (
            <div className="flex flex-wrap gap-2">{facilities.map((item) => <Badge key={item} variant="secondary">{item}</Badge>)}</div>
          )}
        </div>

        <div className="flex flex-col gap-2 sm:flex-row lg:w-44 lg:flex-col">
          <Button asChild><Link to={marinaDetailPath(marina, prefix)}>{copy.openHub}</Link></Button>
          <Button variant="outline" onClick={() => onPreview?.(marina)}><Compass className="h-4 w-4" /> {copy.preview}</Button>
        </div>
      </div>
    </article>
  );
}